import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import AccordionComponent from "../components/Accordion.jsx";

const SELECTORS = {
  list: "[data-accordion-items]",
  item: "[data-accordion-item]",
  trigger: "[data-accordion-item-trigger]",
  body: "[data-accordion-item-body]",
};

export default class Accordion extends BaseModule {
  init() {
    this.listEl = this.el.querySelector(SELECTORS.list);
    this.items = this.collectItems();

    if (!this.items.length) {
      return;
    }

    this.mountTarget = document.createElement("div");
    this.mountTarget.className = "b-accordion__app";

    if (this.listEl) {
      this.listEl.hidden = true;
      this.listEl.after(this.mountTarget);
    } else {
      this.el.appendChild(this.mountTarget);
    }

    this.render();
  }

  collectItems() {
    const nodes = Array.from(this.el.querySelectorAll(SELECTORS.item));

    return nodes
      .map((node, index) => {
        const trigger = node.querySelector(SELECTORS.trigger);
        const body = node.querySelector(SELECTORS.body);

        const title = trigger ? trigger.textContent.trim() : "";
        const bodyHTML = body ? body.innerHTML.trim() : "";

        if (!title && !bodyHTML) {
          return null;
        }

        return {
          id: node.id || `accordion-item-${index}`,
          title,
          body: bodyHTML,
          defaultOpen: this.isDefaultOpen(node),
        };
      })
      .filter(Boolean);
  }

  isDefaultOpen(node) {
    const attr = node.getAttribute("data-accordion-item-open");

    if (attr === "" || attr === "true" || attr === "1") {
      return true;
    }

    return false;
  }

  render() {
    if (!this.mountTarget) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mountTarget);
    }

    this.reactRoot.render(
      createElement(AccordionComponent, {
        items: this.items,
      })
    );
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    if (this.listEl) {
      this.listEl.hidden = false;
    }

    if (this.mountTarget) {
      this.mountTarget.remove();
    }

    this.mountTarget = null;
    this.items = [];
  }
}
